export const shareContent = async (
  title: string,
  text: string,
  url: string
): Promise<void> => {
  try {
    // Check if Web Share API is available
    if (navigator.share && navigator.canShare) {
      const shareData = { title, text, url };
      // Check if the data can be shared
      if (navigator.canShare(shareData)) {
        await navigator.share(shareData);
        return;
      }
    }
    
    // Fallback to clipboard if Web Share API is not available or fails
    await navigator.clipboard.writeText(url);
    // Return a resolved promise to indicate success
    return Promise.resolve();
  } catch (error) {
    // If clipboard fails too, create a temporary input element
    const input = document.createElement('input');
    input.value = url;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    
    // Return a resolved promise since we handled the fallback
    return Promise.resolve();
  }
};